// extracted by css-extract-rspack-plugin
export default {"numericInputContainerGroup":"numericInputContainerGroup-KnWy_0","hideOutsourcing":"hideOutsourcing-Q64uCT"};